import { render, staticRenderFns } from "./read.vue?vue&type=template&id=1dc93190&scoped=true"
import script from "./read.vue?vue&type=script&lang=js"
export * from "./read.vue?vue&type=script&lang=js"
import style0 from "./read.vue?vue&type=style&index=0&id=1dc93190&prod&lang=css"
import style1 from "./read.vue?vue&type=style&index=1&id=1dc93190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc93190",
  null
  
)

export default component.exports